import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import mainSlice from "../store/mainSlice";
import accountSlice from "../store/accountSlice";
export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}),
  reducer: {
    main: mainSlice,
    account: accountSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
